export const SUPPORTED_AUDIO_FORMATS = {
  'audio/aac': 'aac',
  'audio/vnd.dlna.adts': 'adt',
  'audio/x-aiff': 'aif',
  'audio/basic': 'au',
  'audio/x-mpegurl': 'm3u',
  'audio/mp4': 'm4a',
  'audio/midi': 'mid',
  'audio/mpeg': 'mp3',
  'audio/wav': 'wav',
  'audio/x-ms-wax': 'wax',
  'audio/x-ms-wma': 'wma',
  'audio/x-midi': 'midi',
  'audio/ogg': 'ogg',
  'audio/opus': 'opus',
  'audio/webm': 'webm',
  'audio/3gpp': '3gp',
  'audio/3gpp2': '3g2',
  'audio/x-wav': 'wav',
  'audio/flac': 'flac',
  'audio/x-m4a': 'm4a'
};
